import { create } from 'zustand';

interface IPricingState {
    mode: 'annual' | 'monthly';
    setMode: (mode: boolean) => void;
    set: (state: Partial<IPricingState>) => void;
}

export const usePricingState = create<IPricingState>((set) => ({
    mode: 'annual',
    setMode: (mode) => {
        set({ mode: mode ? 'annual' : 'monthly' });
    },
    set: (state) => {
        set(state);
    },
}));
